import React, {useEffect, useState} from "react";
import AdminPanelLayaut from "./layaut/AdminPanelLayaut";
import {addUzytkownika, getUzytkownicy, setAktywny, setHaslo, setUsun, setZablokuj} from "../Services";
import {Button, Flex, Form, Input, message, Modal, Popconfirm, Table, Tag} from "antd";
import { StopOutlined, CheckCircleOutlined, DeleteOutlined, KeyOutlined } from '@ant-design/icons';
import {Link, useNavigate} from "react-router-dom";
import dayjs from "dayjs";
import {getUserInfo, isEmpty} from "../../../GlobalServices";

const Uzytkownicy = () => {
    const navigate = useNavigate();
    const [uzytkownicy, setUzytkownicy] = useState();
    const [showAdd, setShowAdd] = useState(false);
    const [showZmianaHasla, setShowZmianaHasla] = useState(false);
    const [editUser, setEditUser]: any = useState([]);
    const [dodawanie, setDodawanie] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();

    useEffect(() => {
        pobierzUzytkownikow();
    }, []);

    const pobierzUzytkownikow = () => {
        getUzytkownicy().then((response) => {
            setUzytkownicy(response.data);
        }).catch((error) => {
            console.log('error');
        });
    }

    const onClickDodaj = (form: any) => {
        setDodawanie(true);

        addUzytkownika(form).then((response) => {
            onClickCancel();
            pobierzUzytkownikow();
            setDodawanie(false);
        }).catch((error) => {
            console.log('error');
            setDodawanie(false);
        });
    }

    const onClickCancel = () => {
        setShowAdd(false);
    }

    const onClickCancelZmianaHasla = () => {
        setShowZmianaHasla(false);
        form.resetFields();
    }

    const onClickAktywuj = (login: any) => {
        setAktywny(login).then((response) => {
            messageApi.open({
                type: 'success',
                content: `Użytkownik ${login} został aktywowany`,
                duration: 5,
            });
            pobierzUzytkownikow();
        }).catch((error) => {
            console.log('error');
        });
    }
    const onClickZablokuj = (login: any) => {
        setZablokuj(login).then((response) => {
            messageApi.open({
                type: 'success',
                content: `Użytkownik ${login} został zablokowany`,
                duration: 5,
            });
            pobierzUzytkownikow();
        }).catch((error) => {
            console.log('error');
        });
    }

    const onClickUsun = (login: any) => {
        setUsun(login).then((response) => {
            messageApi.open({
                type: 'success',
                content: `Użytkownik ${login} został usunięty`,
                duration: 5,
            });
            pobierzUzytkownikow();
        }).catch((error) => {
            console.log('error');
        });
    }

    const onClickZmienHaslo = (row: any) => {

        if(row.login === getUserInfo()?.uzytkownik?.username){
            navigate('/admin/ustawienia');
        } else {
            setEditUser(row);
            setShowZmianaHasla(true);
        }
    }

    const zmienHaslo = (form: any) => {
        let dane = {
            login: editUser?.login,
            pass: form.pass
        }

        // console.log(dane);

        setHaslo(dane).then((response) => {
            onClickCancelZmianaHasla();

            messageApi.open({
                type: 'success',
                content: `Zmieniono hasło`,
                duration: 5,
            });
        }).catch((error) => {
            console.log('error');
            messageApi.open({
                type: 'error',
                content: `Wystąpił błąd`,
                duration: 5,
            });
        })
    }

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Login',
            dataIndex: 'login',
            key: 'login',
        },
        {
            title: 'Firma',
            dataIndex: 'ctxFirma',
            key: 'firma',
            render: (firma: any) => firma.toUpperCase(),
        },
        {
            title: 'Aktywny',
            dataIndex: 'aktywny',
            key: 'aktywny',
            render: (data: any) => data === 1 ? <Tag color="success">Tak</Tag> : <Tag color="error">Nie</Tag>,
        },
        {
            title: 'Data zmiany',
            dataIndex: 'dataZmiany',
            key: 'dataZmiany',
            render: (data: any) => isEmpty(data) ? '-' : dayjs(data).format('YYYY-MM-DD HH:mm'),

        },
        {
            title: 'Data wpisu',
            dataIndex: 'dataWpisu',
            key: 'dataWpisu',
            render: (data: any) => dayjs(data).format('YYYY-MM-DD HH:mm'),

        },
        {
            title: 'Akcja',
            dataIndex: 'id',
            key: 'akcja',
            render: (id: any, row: any) => <Flex gap={5}>
                {(row.aktywny === 1) ?
                    <Button type="default" icon={<StopOutlined/>} size={'small'} title={'Zablokuj dostęp'} onClick={() => onClickZablokuj(row.login)}/>
                    :
                    <Button type="default" icon={<CheckCircleOutlined/>} size={'small'} title={'Aktywuj dostęp'} onClick={() => onClickAktywuj(row.login)}/>
                }
                <Button type="default" icon={<KeyOutlined />} size={'small'} title={'Zmień hasło'} onClick={() => onClickZmienHaslo(row)}/>
                <Popconfirm
                    title="Czy jesteś pewien?"
                    description={`Czy na pewno chcesz usunąć użytkownika ${row.login}?`}
                    onConfirm={() => onClickUsun(row.login)}
                    okText="Tak, usuń"
                    cancelText="Anuluj"
                >
                    <Button type="default" danger icon={<DeleteOutlined />} size={'small'} title={'Usuń użytkownika'}/>
                </Popconfirm>
            </Flex>,
        },
    ];

    return (
        <AdminPanelLayaut label={'Użytkownicy'}>
            <Flex style={{paddingBottom: '15px'}}><Button onClick={() => setShowAdd(true)}>Nowy użytkownik</Button></Flex>
            <Table dataSource={uzytkownicy} columns={columns} />

            <Modal
                title="Nowy użytkownik"
                open={showAdd}
                onCancel={onClickCancel}
                footer={null}
            >
                <Form
                    name="basic"
                    // labelCol={{ span: 8 }}
                    // wrapperCol={{ span: 24 }}
                    style={{ paddingTop: '15px' }}
                    initialValues={{ remember: true }}
                    onFinish={onClickDodaj}
                    onFinishFailed={() => console.log('error')}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Login"
                        name="login"
                        rules={[{ required: true, message: 'Pole wymagane' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Firma"
                        name="ctx_firma"
                        rules={[{ required: true, message: 'Pole wymagane' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Hasło"
                        name="pass"
                        rules={[{ required: true, message: 'Pole wymagane' }]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item>
                        <Flex justify={'space-between'}>
                            <Button type="default" onClick={onClickCancel}>
                                Anuluj
                            </Button>
                            <Button type="primary" htmlType="submit" loading={dodawanie}>
                                Dodaj użytkownika
                            </Button>
                        </Flex>
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Zmiana hasła"
                open={showZmianaHasla}
                onCancel={onClickCancelZmianaHasla}
                footer={null}
            >
                <Form
                    name="basic"
                    form={form}
                    // labelCol={{ span: 8 }}
                    // wrapperCol={{ span: 24 }}
                    style={{ paddingTop: '15px' }}
                    initialValues={{ remember: true }}
                    onFinish={zmienHaslo}
                    onFinishFailed={() => console.log('error')}
                    autoComplete="off"
                >
                    <p style={{fontWeight: 'bold', textAlign: 'center'}}>{editUser?.login}</p>

                    <Form.Item
                        label="Hasło"
                        name="pass"
                        rules={[{ required: true, message: 'Pole wymagane' }]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item>
                        <Flex justify={'space-between'}>
                            <Button type="default" onClick={onClickCancelZmianaHasla}>
                                Anuluj
                            </Button>
                            <Button type="primary" htmlType="submit" loading={dodawanie}>
                                Zmień hasło
                            </Button>
                        </Flex>
                    </Form.Item>
                </Form>
            </Modal>
            {contextHolder}
        </AdminPanelLayaut>
    )
}

export default Uzytkownicy;
